import React from 'react';
import Navigation from './Navigation';
import HamburgerMenu from './HamburgerMenu';
import styles from './Header.module.css';

const Header = () => {
    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <a href="/" className={styles.logoLink}>
                    <h1 className={styles.logo}>
                        <span className={styles.hyphen}>-</span>
                        <span className={styles.brandName}>Apexbit</span>
                        <span className={styles.hyphen}>-</span>
                    </h1>
                </a>
                
                {/* Desktop Navigation (includes Get Started button) */}
                <div className={styles.desktopNav}>
                    <Navigation />
                </div>
                
                {/* Mobile Hamburger Menu */}
                <div className={styles.mobileNav}>
                    <HamburgerMenu />
                </div>
            </div>
        </header>
    );
};

export default Header;